import Footer from "../Footer/Footer";
import Header from "../Header";
import Topnav from "../TopNav/Topnav";
import ShortFilmGrid from "./ShortfilmGrid";

const ShortFilmUpload =()=>{
  return(
    <>
    <Topnav/>
    <Header/>
    <ShortFilmGrid/>
    <Footer/>
    </>
  )
}
export default ShortFilmUpload;